import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BranchMasterComponent } from "./branch-master/branch-master.component";
import { AccountHeadMasterComponent } from "./Company-Setup/account-head-master/account-head-master.component";
import { AccountMasterComponent } from "./Company-Setup/account-master/account-master.component";
import { AccountTypeMasterComponent } from "./Company-Setup/account-type-master/account-type-master.component";
import { CompanyMasterComponent } from "./Company-Setup/company-master/company-master.component";
import { SurgeryMasterComponent } from "./medical-record/sugery-master/surgery-master.component";
import { RoomCategoryMasterComponent } from "./billing-master/room-category-master/room-category-master.component";
import { OperationTheatreMasterComponent } from "./medical-record/operation-theatre-master/operation-theatre-master.component";
import { RateListMasterComponent } from "./billing-master/rate-list-master/rate-list-master.component";

import { PackageMasterComponent } from "./billing-master/package-master/package-master.component";
import { ConsentMasterComponent } from "./consent-master/consent-master.component";
import { CheckListMasterComponent } from "./checklist-master/checklist-master.component";
import { DiagnosisMasterComponent } from "./diagnosis-master/diagnosis-master.component";
import { OPDTestMasterComponent } from "./opdtest-master/opdtest-master.component";
import { CategorymasterComponent } from "./categorymaster/categorymaster.component";
import { BillCategoryMasterComponent } from "./billing-master/bill-category-master/bill-category-master.component";
import { BillTypeMasterComponent } from "./billing-master/bill-type-master/bill-type-master.component";
import { PayTypeMasterComponent } from "./billing-master/pay-type-master/pay-type-master.component";
import { DepositTypeMasterComponent } from "./billing-master/deposit-type-master/deposit-type-master.component";
import { BillSeriesMasterComponent } from "./billing-master/bill-series-master/bill-series-master.component";
import { DoctorAccountingModuleComponent } from "./billing-master/doctor-accounting-module/doctor-accounting-module.component";
import { ComplaintCategoryMasterComponent } from "./medical-record/complaint-category-master/complaint-category-master.component";
import { ComplaintMasterComponent } from "./medical-record/complaint-master/complaint-master.component";
import { ReferredAccoutingModuleComponent } from "./billing-master/referred-accouting-module/referred-accouting-module.component";
import { MedicineCatgeoryMasterComponent } from "./medical-record/medicine-catgeory-master/medicine-catgeory-master.component";
import { MedicineMasterComponent } from "./medical-record/medicine-master/medicine-master.component";
import { DosageMasterComponent } from "./medical-record/dosage-master/dosage-master.component";
import { MedicineManufacturerMasterComponent } from "./medical-record/medicine-manufacturer-master/medicine-manufacturer-master.component";
import { OperationTypeMasterComponent } from "./medical-record/operation-type-master/operation-type-master.component";
import { ScheduleTypeMasterComponent } from "./schedule-master/schedule-type-master/schedule-type-master.component";
import { OpdScheduleManagerComponent } from "./schedule-master/opd-schedule-manager/opd-schedule-manager.component";
import { SurgicalScheduleMasterComponent } from "./schedule-master/surgical-schedule-master/surgical-schedule-master.component";

// import { ReportMasterComponent } from "./report-master/report-master.component";

const routes: Routes = [
  { path: "branchMaster", component: BranchMasterComponent },
  { path: "accountHeadMaster", component: AccountHeadMasterComponent },
  { path: "accountTypeMaster", component: AccountTypeMasterComponent },
  { path: "accountMaster", component: AccountMasterComponent },
  { path: "companyMaster", component: CompanyMasterComponent },
  { path: "surgeryMaster", component: SurgeryMasterComponent },
  { path: "roomCategoryMaster", component: RoomCategoryMasterComponent },
  { path: "rateListMaster", component: RateListMasterComponent },
  { path: "packageMaster", component: PackageMasterComponent },
  { path: "consentMaster", component: ConsentMasterComponent },
  { path: "checkListMaster", component: CheckListMasterComponent },
  { path: "diagnosisMaster",component:DiagnosisMasterComponent},
  { path: "opdtestMaster",component:OPDTestMasterComponent},
  { path: "categoryMaster",component:CategorymasterComponent},
  { path: "OperationTheatreMaster",component: OperationTheatreMasterComponent,},
  { path:"BillCategoryMaster",component: BillCategoryMasterComponent,},
  { path:"BillTypeMaster",component: BillTypeMasterComponent,},
  { path:"PayTypeMaster",component: PayTypeMasterComponent,},
  { path:"DepositTypeMaster",component: DepositTypeMasterComponent,},
  { path:"BillSeriesMaster",component: BillSeriesMasterComponent,},
  { path:"DoctorAccountModule",component: DoctorAccountingModuleComponent,},
  { path:"Complaintcategorymaster",component: ComplaintCategoryMasterComponent,},
  { path:"Complaintmaster",component: ComplaintMasterComponent,},
  { path:"Referredaccountingmodule",component: ReferredAccoutingModuleComponent,},
  { path:"Medicinecategorymaster",component: MedicineCatgeoryMasterComponent,},
  { path:"Medicinemaster",component: MedicineMasterComponent,},
  { path:"DosageMaster",component: DosageMasterComponent,},
  { path:"MedicinemanufacturerMaster",component: MedicineManufacturerMasterComponent,},
  { path:"OperationTypeMaster" , component:OperationTypeMasterComponent,},
  { path:"scheduletypeMaster" , component: ScheduleTypeMasterComponent,},
  { path:"opdscheduleManager" , component:OpdScheduleManagerComponent,},
  { path:"surgicalscheduleMaster" , component:SurgicalScheduleMasterComponent,},

  // { path:"reportMaster" , component:ReportMasterComponent,},

  {
    path: "location",
    loadChildren: () =>
      import("../masters/location-master/location-master.module").then(
        (m) => m.LocationMasterModule
      ),
  },
  {
    path: "configuration",
    loadChildren: () =>
      import("../masters/configuration/configuration.module").then(
        (m) => m.ConfigurationModule
      ),
  },
  {
    path: "usermanagement",
    loadChildren: () =>
      import("../masters/user-management/user-management.module").then(
        (m) => m.UserManagementModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MastersRoutingModule {}
